module.exports = __webpack_public_path__ + "static/media/Verbandkasten_aktiv_blockiert.7a19c8dd.png";